import ReactDOM from "react-dom";
import { useRef, useState } from "react";
import useModalEvent from "../../hooks/useModalEvent";
import { Modal } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useDeleteView } from "../../data/mutations/viewMutations";
import { useQueryClient } from "@tanstack/react-query";
import { useBoardProvider } from "../../contexts/board/boardContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const DeleteViewConfirmationModal = () => {
  const { t } = useTranslation(["DeleteViewConfirmationModal", "Shared"]);
  const modalRef = useRef(null);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [visible, setVisible] = useState(false);
  const { mutate: deleteView } = useDeleteView();
  const { currentBoardId } = useBoardProvider();
  const viewId = useRef(null);

  const toggleModal = (e) => {
    viewId.current = e.detail;
    modalRef.current?.open(e);
  };

  const onDelete = async () => {
    if (!viewId.current.Id) error();
    else
      deleteView(
        {
          id: viewId.current.Id,
        },
        {
          onSuccess: success,
          onError: () => error(),
          onSettled: () => modalRef.current?.close(),
        }
      );
  };

  const error = () => {
    toast.error(t("Error"), {
      position: "bottom-left",
    });
  };

  const success = (_, payload) => {
    queryClient.invalidateQueries({
      queryKey: ["get-views", currentBoardId],
    });
    queryClient.invalidateQueries({
      queryKey: ["get-view", payload.id],
    });
    navigate(`/duedates/views/assignedtome?boardid=${currentBoardId}`);
    toast.success(t("Success"), {
      position: "bottom-left",
    });
  };

  const close = () => {
    viewId.current = null;
    setVisible(false);
  };

  const open = () => {
    setVisible(true);
  };

  useRegisterEvent(ModalEvents.DeleteViewConfirmationModal, toggleModal);

  return ReactDOM.createPortal(
    <Modal
      id={ModalEvents.DeleteViewConfirmationModal.Id}
      ref={modalRef}
      visible={visible}
      open={open}
      close={close}
      isModal
      buttons={[
        {
          buttonModel: {
            content: t("Cancel"),
            cssClass: "cancel-btn",
            isPrimary: true,
          },
          click: () => setVisible(false),
        },
        {
          buttonModel: {
            id: ModalEvents.DeleteViewConfirmationModal.Id + "_delete-button",
            content: t("Delete"),
            cssClass: "delete-btn",
            isPrimary: true,
          },
          click: () => onDelete(),
        },
      ]}
    >
      <p className="title">{t("Title")}</p>
      <p className="mt-2">{t("Message")}</p>
    </Modal>,
    document.body
  );
};
